import React from "react";
import { FaInfoCircle } from "react-icons/fa";

interface PaymentScheduleAlertProps {
  className?: string;
}

/**
 * Nota informativa sobre as datas dos lotes de pagamento:
 * dias 01, 10 e 20 de cada mês, com ajuste para dia útil.
 */
const PaymentScheduleAlert: React.FC<PaymentScheduleAlertProps> = ({
  className,
}) => {
  return (
    <div
      className={`flex items-start gap-2 rounded-lg border border-blue-100 bg-blue-50/50 px-3 py-2 text-[13px] leading-snug text-slate-600 ${
        className ?? ""
      }`}
    >
      <FaInfoCircle className="mt-0.5 shrink-0 text-blue-400" />
      <p>
        Pagamentos são processados nos dias{" "}
        <span className="font-semibold text-slate-700">01</span>,{" "}
        <span className="font-semibold text-slate-700">10</span> e{" "}
        <span className="font-semibold text-slate-700">20</span> de cada mês
        (movidos para o próximo dia útil quando caem em fim de semana ou
        feriado). Envie o relatório antes dessas datas para entrar no próximo
        lote.
      </p>
    </div>
  );
};

export default PaymentScheduleAlert;
